import React from "react"
import { BodyTextSemibold } from "../typography/text"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { BodyHeader2Semibold } from "../typography/body-headings"
import { IconWrapper } from "../IconWrapper"

export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  leftIcon?: React.ReactNode
  leftText?: string
  rightIcon?: React.ReactNode
  rightText?: string
  leftCenterIcon?: React.ReactNode
  rightCenterIcon?: React.ReactNode
  size: "small" | "medium" | "large"
  isLoading?: boolean
  isRounded?: boolean
}

export const ButtonBase = ({
  children,
  className,
  leftIcon,
  leftText,
  rightIcon,
  rightText,
  leftCenterIcon,
  rightCenterIcon,
  size,
  isLoading,
  isRounded,
  type,
  ...rest
}: ButtonProps) => {
  return (
    <button
      type={type || "button"}
      className={`flex flex-row ${
        isLoading ? "justify-center" : "justify-between"
      } items-center gap-4 ${isRounded ? "rounded-full" : "rounded-md"} ${
        size === "small"
          ? "py-1 px-[10px]"
          : size === "medium"
            ? "py-2 px-3"
            : "py-3 px-4"
      }  disabled:text-textSecondary2 disabled:cursor-not-allowed active:scale-[98%] transition duration-200 ${
        className ? className : ""
      }`}
      {...rest}
    >
      {isLoading ? (
        <BodyTextSemibold>
          <FontAwesomeIcon icon={solid("spinner")} spin />
        </BodyTextSemibold>
      ) : (
        <>
          {(leftIcon || leftText) && (
            <div className="flex flex-row w-full gap-2 justify-start">
              {leftIcon && <IconWrapper>{leftIcon}</IconWrapper>}
              {leftText && <BodyTextSemibold>{leftText}</BodyTextSemibold>}
            </div>
          )}
          {children && (
            <div className="flex flex-row w-full gap-2 justify-center">
              {leftCenterIcon && <IconWrapper>{leftCenterIcon}</IconWrapper>}
              {isRounded ? (
                <BodyHeader2Semibold className="whitespace-nowrap">
                  {children}
                </BodyHeader2Semibold>
              ) : (
                <BodyTextSemibold className="whitespace-nowrap">
                  {children}
                </BodyTextSemibold>
              )}
              {rightCenterIcon && <IconWrapper>{rightCenterIcon}</IconWrapper>}
            </div>
          )}
          {(rightIcon || rightText) && (
            <div className="flex flex-row w-full gap-2 justify-end">
              {rightText && <BodyTextSemibold>{rightText}</BodyTextSemibold>}
              {rightIcon && <IconWrapper>{rightIcon}</IconWrapper>}
            </div>
          )}
        </>
      )}
    </button>
  )
}
